import { defineRecipe } from '@chakra-ui/react';

export const iconRecipe = defineRecipe({
  className: 'ac-icon',
  base: {},

  variants: {
    variant: {
      error: {
        stroke: 'halton.red',
      },
      info: {
        stroke: 'halton.blue',
      },
      success: {
        stroke: 'halton.green',
      },
      warning: {
        stroke: 'halton.yellow',
      },
      neutral: {
        stroke: 'grey.dark.1',
      },
    },
    size: {
      xxs: {
        width: '12px',
        height: '12px',
        minH: '12px',
      },
      xs: {
        width: '16px',
        height: '16px',
        minH: '16px',
      },
      sm: {
        width: '22px',
        height: '22px',
        minH: '22px',
      },
      md: {
        width: '28px',
        height: '28px',
        minH: '28px',
      },
      lg: {
        width: '32px',
        height: '32px',
        minH: '32px',
      },
      xl: {
        width: '48px',
        height: '48px',
        minH: '48px',
      },
    },
  },
  defaultVariants: {
    size: 'md',
    variant: 'neutral',
  },
});
